import Cast from 'scratch-vm/src/util/cast';

class CIPMasterBlock {
    constructor() {
        this.masterKeys = [
            {
                text: 'RED',
                value: '#ff0000'
            },
            {
                text: 'ORANGE',
                value: '#ff9b00'
            },
            {
                text: 'YELLOW',
                value: '#ffff00'
            },
            {
                text: 'GREEN',
                value: '#00ff00'
            },
            {
                text: 'BLUE',
                value: '#0000ff'
            },
            {
                text: 'PURPLE',
                value: '#ff00ff'
            },
            {
                text: 'WHITE',
                value: '#ffffff'
            },
        ];
    }

    runMasterBlock() {

    }
    

    masterColorControl (masterBlock, color) {
        if (!masterBlock) {
            return {
                result: false,
                error: '[Error] The master block is not connected.',
            };
        }

        // console.log("color", color)
        const rgb = Cast.toRgbColorObject(color);
        // console.log("rgb", rgb)
        // const hsv = Color.rgbToHsv(rgb);
        // console.log("hsv", hsv)

        masterBlock.colorControl(rgb);

        return new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, 500);
        });
    }

    masterColorOffControl (masterBlock) {
        if (!masterBlock) {
            return {
                result: false,
                error: '[Error] The master block is not connected.',
            };
        }

        const rgb = {r: 0, g: 0, b: 0};
        masterBlock.colorControl(rgb);

        return new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, 200);
        });
    }

    masterColor2 (masterBlock, key) {
        if (!masterBlock) {
            return {
                result: false,
                error: '[Error] The master block is not connected.',
            };
        }

        const masterKey = Cast.toString(key).toUpperCase();

        const data = this.masterKeys.find((mk) => mk.text === masterKey) ?? this.masterKeys[this.masterKeys.length - 1];

        const rgb = Cast.toRgbColorObject(data.value);
        masterBlock.colorControl(rgb);

        return new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, 200);
        });
    }
}

export default CIPMasterBlock;
